module.exports = __webpack_public_path__ + "static/media/tree2.a6e38cb0.obj";